<template>
  <v-app>
    <Topmenubar />
    <v-main>
      <v-card>
        <v-container class="px-0">
          <div class="container">
            <v-list-item>
              <v-btn
                class="mr-3"
                icon
                large
                color="primary"
                dark
                append
                to="/profiles/1"
              >
                <v-icon color="primary">mdi-arrow-left</v-icon>
              </v-btn>
              <v-list-item-title class="display-1 ma-0"
                >Profiel instellingen</v-list-item-title
              >
            </v-list-item>
          </div>
        </v-container>
        <v-divider></v-divider>
      </v-card>
      <v-container>
        <div class="container py-15">
          <p>Instellingen voor dit profiel.</p>
          <v-row>
            <v-col cols="12" md="7">
              <v-card
                elevation="0"
                outlined
                class="border rounded-lg mb-5 pa-5"
              >
                <v-btn
                  color="systemred"
                  large
                  block
                  @click="remove"
                  elevation="0"
                >
                  Profiel opheffen
                </v-btn>

                <v-spacer class="py-4"></v-spacer>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Topmenubar from "../../components/Topmenubar.vue";
export default {
  components: {
    Topmenubar,
  },

  props: {
    profiles: Object,
  },
  data: () => ({}),
};
</script>
 